import { createServerClient } from '@supabase/ssr'
import { cookies } from 'next/headers'

import { type Database } from '../database.types'

const serverComponentClient = (cookieStore: ReturnType<typeof cookies>) => {
  const supabase = createServerClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        get(name: string) {
          return cookieStore.get(name)?.value
        },
      },
    },
  )

  return supabase
}

export default serverComponentClient
